<companyid-content-wrapper classNames="justify-between pt-80px tab:px-5 mob:px-5 mob:flex-col">
    <div class="flex flex-col w-[570px] mr-30px mob:w-full mob:justify-center mob:items-center">
        <span
            class="w-fit mb-15px px-2.5 py-5px rounded-5px bg-secondary-color text-dark text-large-regular"
            i18n="@@business-goals">
            Business goals
        </span>

        <span
            class="text-h3-bold text-dark mb-40px mob:text-center"
            i18n=":@@business-goal-streamline">
            Streamline Business Tracking and Reporting
        </span>

        <companyid-business-goal-buttons class="w-[241px] mob:hidden" />
        <img
            [ngSrc]="'vector' | asset: 'home/business-goal'"
            alt="vector"
            width="250"
            height="298"
            class="absolute left-0 tab:hidden mob:hidden mt-180px" />
    </div>
    <div class="flex flex-col gap-y-60px">
        @for (business of businessGoals; track business.title) {
            <div class="flex flex-col">
                <div class="mb-15px rounded-5px bg-dark h-7 w-7 flex justify-center items-center">
                    <img
                        [ngSrc]="business.imgPath | asset: 'home/business-goal'"
                        [alt]="business.title"
                        width="18"
                        height="19" />
                </div>

                <span class="text-dark text-h5-semi-bold mb-5px">{{ business.title }}</span>
                <span class="text-medium-regular text-primary-text-color"
                    >{{ business.subtitle }}.</span
                >
            </div>
        }
    </div>

    <companyid-business-goal-buttons class="w-[241px] tab:hidden desk:hidden mt-40px" />
</companyid-content-wrapper>
